{
  "time_range_error_message": "L'heure de fin doit être postérieure à l'heure de début",
  "attribute_list_items": "éléments de la liste d'attributs",
  "attribute_list_item": "élément de liste d'attributs",
  "attribute_list_item_order": "ordre des éléments de la liste d'attributs"
}